export default __webpack_public_path__ + "static/media/IPERTENSIONE_ICONA.705bc8d4.svg";